import React from "react";
import NavTreeProvider from "./context/provider";
import NavTree from "./NavTreeComponent";

const NavTreeWithProvider = () => {
  return (
    <NavTreeProvider>
      <NavTree />
    </NavTreeProvider>
  );
};

export default NavTreeWithProvider;
